<template>
    <div>
        <v-toolbar flat :dense="dense" :color="toolbarColor" :style="'opacity:'+opacity">
            <v-app-bar-nav-icon v-if="icon">
                <v-icon>{{icon}}</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title class="title pl-2 pb-1">
                {{title}} <span v-if="info.length>0">| </span>
                <span v-if="info.length>0"
                      class="subtitle-1 grey--text text--lighten-1">
                    {{info}}
                </span>
            </v-toolbar-title>

            <!-- HELP ICON -->
            <v-tooltip top color="primary" v-if="help">
                <template v-slot:activator="{ on }">
                    <v-btn
                            @click="helpClicked(help)"
                            v-on="on"
                            icon>
                        <v-icon
                                @mouseover="helpIconColor='white'"
                                @mouseout="helpIconColor='grey lighten-1'"
                                :color="helpIconColor">mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Additional information</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <slot name="buttons"></slot>

        </v-toolbar>

        <v-progress-linear v-if="loading"
                           class="ma-0 pa-0 grey darken-3"
                           value=100
                           color="blue"
                           height="3"
                           :indeterminate="true"
        ></v-progress-linear>

        <v-progress-linear v-if="!loading"
                           class="ma-0 pa-0"
                           value=100
                           :color="toolbarColor"
                           height="3"
        ></v-progress-linear>

        <help v-if="help"
              v-model="helpDialogModel"
              :identifier="helpIdentifier"
        ></help>
    </div>
</template>

<script>

    import Help from '../../modules/Help/components/index';

    export default {

        name: "material-header",

        components: {
            Help
        },

        props: {
            title: {
                type: String,
                required: true,
                default: 'Anonymous'
            },
            info: {
                type: String,
                required: false,
                default: '',
            },
            toolbarColor: {
                type: String,
                required: false,
                default: 'grey darken-3'
            },
            icon: {
                type: String,
                required: false,
                default: null
            },
            disableIcon: {
                type: Boolean,
                required: false,
                default: false
            },
            dense: {
                type: Boolean,
                required: false,
                default: false
            },
            loading: {
                type: Boolean,
                required: false,
                default: false,
            },
            help: {
                type: String,
                required: false,
                default: null
            },
            opacity: {
                type: Number,
                required: false,
                default: 1
            }
        },

        data() {
            return {
                helpIconColor: 'grey lighten-1',
                helpDialogModel: false,
                helpIdentifier: null,
            }
        },

        methods: {
            helpClicked(id) {
                this.helpIdentifier = id;
                this.helpDialogModel = true;
            }
        }
    }
</script>
